import axios from "axios";
import BusyLoader from "../common/BusyLoader";
import CommonUtil from "../common/CommonUtil";

//const url = "https://rcmapi-qa.rehrigbdp.com";
//const url = "https://devapi.rehrigbdp.com"; // old dev-api
const url = process.env.REACT_APP_SERVER_URL // new dev-api

let config = {
    headers: {
        'Authorization': 'Bearer 1'
    }
}
axios.interceptors.request.use(
  config => {
      CommonUtil.getIDToken();
      if (CommonUtil.sessionKey) {
          config.headers['Authorization'] = "Bearer " + CommonUtil.sessionKey;
      }
      return config;
  },
  error => Promise.reject(error)
);


export const getAllDevices = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/device/all`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data.devices
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
};

export const getAvailableDevices = (sg1,sp1) => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/device/available?deviceUsageType=&segmentId=${sg1}&serviceProviderId=${sp1}`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
};


//api/device/available?segmentId=s1&serviceProviderId=sp1

export const getAllDeviceTypes = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/device/types`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
};

export const getAllDeviceByStatus = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/devicecountbystatus`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getTotalTrucks = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/truckcount`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getAllSPCount = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/spcount`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getAlldevicecountbysp = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/devicecountbysp`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getAllMissingHeartBeatForDeviceBySP = () => {
  BusyLoader.showLoader();
  return axios.get(`${url}/api/dashboard/missingheartbeatin24hrsbysp`)
    .then(res => {
      BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
      BusyLoader.hideLoader();
      return e
    })
};

export const getAlltruckcountbysp = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/truckcountbysp`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getdevicesAddedLastYear = () => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/dashboard/lastyear`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getdevicesByMonth = () => {
  //bymonth?creationMonthYYYYMM=202212
  const Currmonth = localStorage.getItem('monthSelected')
  BusyLoader.showLoader();
return axios.get(`${url}/api/device/bymonth?creationMonthYYYYMM=${Currmonth}`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
    BusyLoader.hideLoader();
    return e
  })
};

export const getdevicesbyStatus = (DStatus, DType, segId, spId, fDate, tDate, pgNumber) => {
    BusyLoader.showLoader();
return axios.get(`${url}/api/report/devicestatus?deviceStatus=${DStatus}&deviceType=${DType}&fromDate=${fDate}&pageNumber=${pgNumber}&segmentId=${segId}&serviceProviderId=${spId}&toDate=${tDate}`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
    BusyLoader.hideLoader();
    return e
  })
};

export const getMissingDevicesbyDay = (DStatus, DEventTime, spId, pgNumber) => {
  BusyLoader.showLoader();
  return axios.get(`${url}/api/report/missingdevices?deviceStatus=${DStatus}&eventTime=${DEventTime}&pageNumber=${pgNumber}&serviceProviderId=${spId}`)
    .then(res => {
      BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
      BusyLoader.hideLoader();
      return e
    })
};

export const getDeviceTraceById = (devId) => {
  BusyLoader.showLoader();
return axios.get(`${url}/api/device/${devId}/trace`)
  .then(res => {
      BusyLoader.hideLoader();
    return res.data
  })
  .catch(e => {
      BusyLoader.hideLoader();
    return e
  })
};

export const getDeviceDetailsById = (devId) => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/device/${devId}`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data;
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}



export const getTruckAllTypes = () => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/truck/trucktypes`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
};

export const getTruckAllServiceTypes = () => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/truck/servicetypes`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
};

export const getTruckAllFuelTypes = () => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/truck/fueltypes`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
};



export const getAllServiceProviders = () => {
    BusyLoader.showLoader();
  return axios.get(`${url}/api/truck/serviceproviders`)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
};

export const addDevice = (body) => {
    BusyLoader.showLoader();
  return axios.post(`${url}/api/device/`, body)
    .then(res => {
        BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
        BusyLoader.hideLoader();
      return e
    })
}

export const getTruckDetails = (truckId) => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/truck/${truckId}`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}

export const getTagSchemeDetails = (truckId) => {
    BusyLoader.showLoader();
    return axios.get(`${url}/api/tagscheme/${truckId}`)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}

export const addTruck = (body) => {
    BusyLoader.showLoader();
  return axios.post(`${url}/api/truck/`, body)
      .then(res => {
          BusyLoader.hideLoader();
        return res.data
      })
      .catch(e => {
          BusyLoader.hideLoader();
        return e
      })
}
export const addTagScheme = (body) => {
    BusyLoader.showLoader();
    return axios.post(`${url}/api/tagscheme/`, body)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}
export const editTagScheme = (body) => {
    BusyLoader.showLoader();
    return axios.put(`${url}/api/tagscheme/${body.tagSchemeId}`, body)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}
export const deleteTagScheme = (body) => {
    BusyLoader.showLoader();
    return axios.delete(`${url}/api/tagscheme/${body.tagSchemeId}`, body)
        .then(res => {
            BusyLoader.hideLoader();
            return res;
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}
export const editTruck = (body) => {
    BusyLoader.showLoader();
    return axios.put(`${url}/api/truck/${body.truckId}`, body)
        .then(res => {
            BusyLoader.hideLoader();
            return res.data
        })
        .catch(e => {
            BusyLoader.hideLoader();
            return e
        })
}

/*export const deleteTruck = (truckId) => {
    return axios.delete(`${url}/api/truck/${truckId}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            return e
        })
}*/

export const editDevice = (body) => {
  return axios.put(`${url}/api/device/${body.iotDeviceId}`, body)
    .then(res => {
      return res.data
    })
    .catch(e => {
      return e
    })
}

export const deleteDevice = (body) => {
  return axios.delete(`${url}/api/device/${body}`)
    .then(res => {
      return res
    })
    .catch(e => {
      return e
    })
}

export const deleteTruck = (body) => {
    return axios.delete(`${url}/api/truck/${body}`)
        .then(res => {
            return res
        })
        .catch(e => {
            return e
        })
}

export const getAvailableTrucks = (segId, spId) => {
  return axios.get(`${url}/api/truck/available?segmentId=${segId}&serviceProviderId=${spId}`)
    .then(res => {
      return res.data.trucks
    })
    .catch(e => {
      return e
    })
};

export const getAllTrucks = () => {
  return axios.get(`${url}/api/truck/all`)
    .then(res => {
      return res.data.trucks
    })
    .catch(e => {
      return e
    })
};

export const getAllFailedReports = (newTruckId, newDId, pgNumber, body) => {
  BusyLoader.showLoader();
 const fromDate = localStorage.getItem('fromDate');
 const toDate = localStorage.getItem('toDate');
  return axios.get(`${url}/api/report/failed?deviceId=${newDId}&fromDate=${fromDate}&pageNumber=${pgNumber}&toDate=${toDate}&truckId=${newTruckId}`, body)
    .then(res => {
      BusyLoader.hideLoader();
      return res.data
    })
    .catch(e => {
      BusyLoader.hideLoader();
      return e

    })
};

export const getAllSchemes = () => {
    return axios.get(`${url}/api/tagscheme/all`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            return e
        })
};


export const getWareHouses = (body) => {
  return axios.get(`${url}/api/truck/warehouses?segmentId=${body}`)
    .then(res => {
      return res.data
    })
    .catch(e => {
      return e
    })
}

export const getSegment = (body) => {
    return axios.get(`${url}/api/truck/segments/?serviceProviderId=${body}`)
        .then(res => {
            return res.data
        })
        .catch(e => {
            return e
        })
}

export const getAllFailedDeviceEvents = (dId,eType,segId,spId,truckId,pgNumber) => {
    BusyLoader.showLoader();
  const fromDate = localStorage.getItem('fromDate');
  const toDate = localStorage.getItem('toDate');
 // return axios.get(`${url}/api/report/enriched?fromDate=${fromDate}&segmentId=${segID}&serviceProviderId=${SPID}&toDate=${toDate}`, body)
  return axios.get(`${url}/api/report/enriched?deviceId=${dId}&eventType=${eType}&fromDate=${fromDate}&segmentId=${segId}&serviceProviderId=${spId}&toDate=${toDate}&truckNo=${truckId}&pageNumber=${pgNumber}`)
    .then(res => {
      BusyLoader.hideLoader();
      return res.data;
    })
    .catch(e => {
      BusyLoader.hideLoader();
      return e
    })
}

export const getAllFailedTipPushEvents = (eType,pgNumber) => {
  https://rcmapi-dev.rehrigbdp.com/api/report/tippushstatus?eventType=heartbeat&fromDate=01-03-2023&pageNumber=1&toDate=10-03-2023
    BusyLoader.showLoader();
const fromDate = localStorage.getItem('fromDate');
const toDate = localStorage.getItem('toDate');
return axios.get(`${url}/api/report/tippushstatus?eventType=${eType}&fromDate=${fromDate}&pageNumber=${pgNumber}&toDate=${toDate}`)
      .then(res => {
          BusyLoader.hideLoader();
          return res.data;
      })
      .catch(e => {
          BusyLoader.hideLoader();
          return e
      })
}

export const deviceDisassoc = (truckId,deviceId) => {
    return axios.post(`${url}/api/truck/${truckId}/disassociate?iotDeviceId=${deviceId}`)
        .then(res => {
            return res
        })
        .catch(e => {
            return e
        })
}

export const bulkUpload = (deviceTypeName, file) => {
  const formData = new FormData();
  formData.append('importfile', file);
  return axios.post(`${url}/api/device/import`, formData, {
    params: {
      deviceTypeName
    }
  })
    .then(response => {
      return response.data
    })
    .catch(error => {
      return error
    });
}
